import { defineMessages } from 'react-intl'

const translations = defineMessages({
  UNZER_CARDS: {
    defaultMessage: 'Credit Card ({cardType})',
    id: 'msp.account_payment_methods.title.credit_card'
  },
  UNZER_PAYPAL: {
    defaultMessage: 'Paypal',
    id: 'msp.account_payment_methods.title.paypal'
  },
  UNZER_INVOICE: {
    defaultMessage: 'Pay by Invoice',
    id: 'msp.account_payment_methods.title.invoice'
  },
  UNZER_DIRECT_DEBIT_SECURED: {
    defaultMessage: 'Direct Debit Secured',
    id: 'msp.account_payment_methods.title.direct_debit_secured'
  },
  UNZER_LINK_PAY: {
    defaultMessage: 'Link Pay',
    id: 'msp.account_payment_methods.title.link_pay'
  },
  MASTER: {
    defaultMessage: '(Mastercard)',
    id: 'msp.account_payment_methods.title.master_card'
  },
  VISA: {
    defaultMessage: '(Visa)',
    id: 'msp.account_payment_methods.title.visa_card'
  },
  creditCardNumber: {
    defaultMessage: 'Card Number: {number}',
    id: 'msp.account_payment_methods.credit_card.number'
  },
  creditCardValidity: {
    defaultMessage: 'Valid till: {expiryDate}',
    id: 'msp.account_payment_methods.credit_card.validity'
  },
  creditCardExpired: {
    defaultMessage: 'Expired',
    id: 'msp.account_payment_methods.credit_card.expired'
  },
  bankAccountNumber: {
    defaultMessage: 'Account Number: {number}',
    id: 'msp.account_payment_methods.bank_account.account_number'
  },
  iban: {
    defaultMessage: '{holder}{br}IBAN: {number}{br}Address:{br}',
    id: 'msp.account_payment_methods.bank_account.iban'
  },
  bankRoutingNumber: {
    defaultMessage: 'BIC/SWIFT: {number}',
    id: 'msp.account_payment_methods.bank_account.routing_number'
  },
  payPayEmail: {
    defaultMessage: 'PayPal email: {paypalEmail}',
    id: 'msp.account_payment_methods.paypal.email'
  },
  invoicedTo: {
    defaultMessage: 'Billing Address:',
    id: 'msp.account_payment_methods.invoice.billing_address'
  },
  invoicedToBirthday: {
    defaultMessage: 'Birthday: {birthDay}',
    id: 'msp.account_payment_methods.invoice.birthday'
  },
  paymentNote: {
    defaultMessage:
      'Note: You must enter your Paypal log in details when you place an order.',
    id: 'msp.account_payment_methods.note.description'
  }
})

export default translations
